<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-3 px-3"
      dense
      height="30"
    >
      <v-avatar
        tile
        style="border-radius: 5px !important;"
        class="d-flex"
      >
        <img
          :src="(accountProp && accountProp.avatar ? accountProp.avatar.link : '/img/noImage.png')"
          :alt="accountProp.name"
        >
      </v-avatar>
      <v-toolbar-title @click="(accountProp ? getAccountCard(accountProp) : null)">
        <div class="d-flex px-2 mt-3">
          {{ $t('operation') }} {{ accountProp.name }}
          <p
            style="font-size: 12px !important;margin: 7px 12px"
          >
            ({{ $t('operationContent') }})
          </p>
        </div>
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    <v-container>
      <v-row class="mt-2">
        <v-col
          cols="12"
          md="4"
        >
          <template>
            <v-text-field
              id="fromId"
              v-model="fromDate"
              :label="$t('from') + ' ' + $t('date')"
              outlined
              dense
              clearable
            />

            <date-picker
              v-model="fromDate"
              element="fromId"
              :locale="$store.state.date_locale"
              :format="$store.state.date_format"
              auto-submit
              :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
              @close="setDate"
            />
          </template>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <template>
            <v-text-field
              id="toId"
              v-model="toDate"
              :label="$t('until') + ' ' + $t('date')"
              outlined
              dense
              clearable
            />

            <date-picker
              v-model="toDate"
              element="toId"
              :locale="$store.state.date_locale"
              :format="$store.state.date_format"
              :min="fromDate"
              auto-submit
              :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
              @close="setDate"
            />
          </template>
        </v-col>
      </v-row>
      <v-row
        v-if="data"
        class="mx-0"
      >
        <v-col
          cols="12"
        >
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-right">
                    {{ $t('content') }}
                  </th>
                  <th class="text-right">
                    {{ $t('count') }}
                  </th>
                  <th class="text-right">
                    {{ $t('debtor') }} ({{ $store.state.currency.symbol }})
                  </th>
                  <th class="text-right">
                    {{ $t('creditor') }} ({{ $store.state.currency.symbol }})
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in data.in"
                  :key="item.key"
                >
                  <td>{{ $t('enterCountToEntrepotRelatedToUser') }} {{ item.entrepot.name }}</td>
                  <td>{{ item.count_in }}</td>
                  <td>{{ $numberFormat(item.price_in) }}</td>
                  <td />
                </tr>
                <tr v-if="data.sell">
                  <td>{{ $t('productOrserviceSell') }}</td>
                  <td>{{ data.sell.sum_count }} - </td>
                  <td />
                  <td>{{ $numberFormat(data.sell.sum_amount) }}</td>
                </tr>
                <tr v-if="data.returnSell">
                  <td>{{ $t('productOrserviceReturnSell') }}</td>
                  <td>{{ data.returnSell.sum_count }}</td>
                  <td>{{ $numberFormat(data.returnSell.sum_amount) }}</td>
                  <td />
                </tr>
                <tr
                  v-for="item in data.recieve"
                  :key="item.key"
                >
                  <td>{{ $t('recieveAmountTo') }} {{ item.bank.name }}</td>
                  <td />
                  <td />
                  <td>{{ $numberFormat(item.amount) }}</td>
                </tr>
                <tr
                  v-for="item in data.recieve"
                  :key="item.key"
                >
                  <td>{{ $t('payAmountFrom') }} {{ item.bank.name }}</td>
                  <td />
                  <td>{{ $numberFormat(item.amount) }}</td>
                  <td />
                </tr>
                <tr style="background-color: #d3d3d3">
                  <td>{{ $t('remain') }}</td>
                  <td>{{ $numberFormat(data.sumCount) }}</td>
                  <td
                    class="text-center"
                    colspan="2"
                  >
                    {{ $numberFormat(data.sumAmount) }} {{ (data.sumAmount > 0 ? $t('debtor') : (data.sumAmount !== 0 ? $t('creditor') : '') ) }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import General from '@/Mixins/general'
  export default {
    name: 'AccountCard',
    mixins: [General],
    props: ['accountProp'],
    data () {
      return {
        printType: 'unofficial',
        account: null,
        data: null,
        fromDate: null,
        toDate: null,
      }
    },
    watch: {
      accountProp (val) {
        this.account = null
        this.getAccountCard(val)
      },
      fromDate () {
        this.getAccountCard(this.accountProp)
      },
      toDate () {
        this.getAccountCard(this.accountProp)
      },
    },
    mounted () {
      if (this.accountProp) {
        this.getAccountCard(this.accountProp)
      }
    },
    methods: {
      getAccountCard (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'customer', {
          params: {
            getAccountCard: 'active',
            id: item.id,
            fromDate: app.fromDate,
            toDate: app.toDate,
          },
        })
          .then(res => {
            res = res.data
            app.data = res
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>

</style>
